import Home from "./../components/SearchPartnerEB/SearchEBComponent";
import { connect } from "react-redux";
import {cartAction, sideMenuAction, vehicleAction} from "./../store/actions";

const mapStateToProps = state => {
  const {
    authReducer: { isLoggedIn },
    vehicleReducer: {
      searchItemSuccess,
      searchItemError,
      searchItemLoader,
      getHPIPriceSuccess,
      getHPIPriceError,
      getHPIPriceLoader,
      addProductToBasketSuccess,
      addProductToBasketError,
      addProductToBasketLoader,
      getAllProductsSuccess
    },
    cartReducer: {
      cartProducts,
      mergeCartSuccess,
      mergeCartError,
      mergeCartLoader,
      cartProductsReduced
    },
  } = state;
  return {
    searchItemSuccess,
    searchItemError,
    searchItemLoader,
    getHPIPriceSuccess,
    getHPIPriceError,
    getHPIPriceLoader,
    addProductToBasketSuccess,
    addProductToBasketError,
    addProductToBasketLoader,
    getAllProductsSuccess,
    cartProducts,
    mergeCartSuccess,
    mergeCartError,
    mergeCartLoader,
    cartProductsReduced,
    filterReducer: state.filterReducer,
    sideMenuReducer: state.sideMenuReducer,
    isLoggedIn
  };
};

const mapDispatchToProps = dispatch => {
  return {
    searchItem: payload => dispatch(vehicleAction.searchItem(payload)),
    getHPIPrice: payload => dispatch(vehicleAction.getHPIPrice()),
    sideMenuAction: payload => dispatch(sideMenuAction.setSideMenu(payload)),
    addProductToBasket: payload => dispatch(vehicleAction.addProductToBasket(payload)),
    getAllProducts: payload => dispatch(vehicleAction.getAllProducts(payload)),
    addCartProduct: payload => dispatch(cartAction.addCartProduct(payload)),
    mergeCart: payload => dispatch(cartAction.mergeCart(payload)),
    clearCart: payload => dispatch(cartAction.clearCart(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
